// extracted by mini-css-extract-plugin
module.exports = {"container":"appointments__AllowedMediumField__container"};